<template>
  <modal size="xl" @close="$emit('close')">
    <form class="w-full mb-4" @submit.prevent="submit">
      <div class="mb-2">
        <nx-input
          v-model="data.name"
          :errors="form.errors"
          label="Name"
          id="name"
          placeholder="Category Name"
          maxlength="50"
          :focus="true"
        />
      </div>

      <div class="w-full">
        <nx-button
          native-type="submit"
          type="primary"
          :disabled="loading"
        >{{ loading ? 'Loading..' : 'Submit' }}</nx-button>
      </div>
    </form>
  </modal>
</template>

<script>
import Form from "form-backend-validation"

export default {
  name: "ChannelCategoryCreateForm",
  data() {
    return {
      form: new Form(),
      loading: false,
      data: {
        name: ""
      }
    }
  },
  methods: {
    async submit() {
      this.loading = true
      await this.$api.categories
        .create(this.data)
        .then(() => {
          this.$toasted.success('Channel Category created.')
          this.$emit("success")
        })
        .catch(data => {
          if (data.response && data.response.status === 422) {
            this.form.onFail(data)
            this.$error.form()
          }else{
            this.$error.generic()
          }
        })
      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
